import './Alert.css'
import Icon, { ICON } from '../../icons/Icon'

const severityIcons = {
  info: ICON.INFO_CIRCLE,
  success: ICON.CHECK_CIRCLE,
  warning: ICON.EXCLAMATION_TRIANGLE,
  error: ICON.TIMES_CIRCLE,
}

const CustomAlert = ({
  severity = 'info',
  message,
  validationErrors = [],
  onClose,
  children,
  className = '',
}) => {
  const isValidation = validationErrors.length > 0
  const icon = severityIcons[severity] || ICON.INFO_CIRCLE

  return (
    <div className={`custom-alert ${severity} ${className}`}>
      {onClose && (
        <button className="custom-alert-close" onClick={onClose}>
          ×
        </button>
      )}

      <div className="custom-alert-icon">
        <Icon icon={icon} size="2x" />
      </div>

      <div className="custom-alert-content">
        {children || (message && <div>{message}</div>)}

        {isValidation && (
          <div className="custom-alert-errors">
            <ul className="custom-alert-list">
              {validationErrors.map((err, idx) => (
                <li key={`error-${idx}`}>{err}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomAlert
